<!-- eslint-disable vue/multi-word-component-names -->
<script>
export default {
  props: {
    date: {
      type: String || null,
      required: true,
      default: '',
    },
  },
  computed: {
    clockTime: function () {
      return this.convertDateToTime();
    },
  },
  methods: {
    convertDateToTime: function () {
      const fullTime = this.date?.split('T')[1];
      const [hours, minutes] = fullTime?.split(':');
      return `${hours?.toString()?.padStart(2, '0')}:${minutes?.toString()?.padStart(2, '0')}`;
    },
  },
};
</script>
<template>
  <div>
    <div v-if="date">
      {{ clockTime }}
    </div>
    <div v-else>-</div>
  </div>
</template>
<style lang="css"></style>
